import { defineStore } from "pinia";
import { useAuthStore } from "@/stores/authStore";
import eventBus from "~/composables/eventBus";

export const useWS = defineStore("ws", {
    state: () => {
        console.log("init ws state");
        const socket = null;
        return {
            socket,
            link: "",
            isConnected: false,
            reconnectError: false,
            reconnect: true,
            reconnectDelay: 5000,
            reconnectAttempts: 0,
            lastMessage: "",
            connectionError: false,
            externalErrorLogger: null,
            log: true,
            logErrors: true,
        };
    },
    actions: {
        connect(link) {
            if (this.log) console.log("ws::connect", this.socket);
            this.lastMessage = "connect to ws";
            if (!this.socket) {
                this.link = link;
                this.socket = new WebSocket(this.link);
                this.socket.addEventListener("open", this.onConnect);
                this.socket.addEventListener("close", this.onClose);
                this.socket.addEventListener("message", this.onMessage);
                this.socket.addEventListener("error", this.onError);
            }
        },
        onConnect(event) {
            if (this.log) console.log("ws::onConnect", event);
            this.isConnected = true;
            this.reconnectAttempts = 0;
            this.connectionError = false;
            this.socket.send(JSON.stringify({
                type: 'connection',
                user: useAuthStore().accessToken
            }));
        },
        onClose(event) {
            eventBus.$emit("ws_close", event.data);
            this.isConnected = false;
            this.connectionError = true;
            if (this.logErrors) console.log("ws::onClose", event);
            if (this.logErrors)
                console.log(
                    "ws::onClose",
                    `scheduling reconnect in ${this.reconnectDelay}ms`
                );
            setTimeout(() => {
                this.socket = null;
                this.reconnectAttempts++;
                this.connect(this.link);
            }, this.reconnectDelay);
        },
        onMessage(event) {
            // if(this.log) console.log("ws::onMessage", JSON.parse(event.data));
            this.lastMessage = event.data;
            eventBus.$emit("ws_message", JSON.parse(event.data));
            console.log('emitted message to event bus')

        },
        onError(event) {
            this.lastMessage = "discconnect to ws";
            if (this.logErrors) console.error("ws::onError", event);
            if (this.externalErrorLogger) this.externalErrorLogger.logError(event);
            eventBus.$emit("ws_error", event.data);
        },
        send(msg) {
            console.log('send called')
            if (this.socket) {
                this.socket.send(JSON.stringify(msg));
            } else {
                console.log("socket not found");
            }
        },
    },
    getters: {
        get_lastMessage: (state) => state.lastMessage,
    },
});
